<template>
    <div class="member">
        <Head></Head>
        <div class="chartTop">
            <div><!-- 山东省莒县阎庄镇孙家山沟村孙其昌后裔族谱|孙其昌 <span> 共563人</span> --></div>
        </div>
        <div class="chart">
            <orgtree :data="data" @NodeClick="NodeClick"></orgtree>
        </div>
        <!-- <el-button @click="addClick()" type="text" size="small">添加</el-button> -->
        <!-- <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="xm" label="姓名"></el-table-column>
            <el-table-column prop="cym" label="曾用名"></el-table-column>
            <el-table-column prop="ancestorname" label="始祖名讳"></el-table-column>
            <el-table-column prop="befrom" label="发源地"></el-table-column>
            <el-table-column prop="familytree" label="本谱世系"></el-table-column>
            <el-table-column prop="beforefamilytree" label="上游谱中世系"></el-table-column>
            <el-table-column prop="intro" label="家族简介"></el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button @click="viewClick(scope.row)" type="text" size="small">查看</el-button>
                    <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="delClick(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table> -->

        <el-dialog :visible.sync="dialogMember" width="50%">
            <span>
                <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="130px" label-position="left" class="demo-ruleForm">
                    <el-form-item label="分类">
                        <el-radio-group v-model="ruleForm.relation">
                            <el-radio label="1">父母</el-radio>
                            <el-radio label="2">子女</el-radio>
                            <el-radio label="3">兄弟</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="分类">
                        <el-radio-group v-model="ruleForm.type">
                            <el-radio label="0">宗亲</el-radio>
                            <el-radio label="1">养亲</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否改性">
                        <el-radio-group v-model="ruleForm.ischange">
                            <el-radio label="0">否</el-radio>
                            <el-radio label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="姓名">
                        <el-input v-model="ruleForm.xm"></el-input>
                    </el-form-item>
                    <el-form-item label="曾用名">
                        <el-input v-model="ruleForm.cxm"></el-input>
                    </el-form-item>
                    <el-form-item label="改名原因">
                        <el-input v-model="ruleForm.gmyy"></el-input>
                    </el-form-item>
                    <el-form-item label="字">
                        <el-input v-model="ruleForm.zi"></el-input>
                    </el-form-item>
                    <el-form-item label="号">
                        <el-input v-model="ruleForm.hao"></el-input>
                    </el-form-item>
                    <el-form-item label="世序">
                        <el-input v-model="ruleForm.shixu"></el-input>
                    </el-form-item>
                    <el-form-item label="辈分第几字">
                        <!-- <el-input v-model="ruleForm.bfdjz"></el-input> -->
                        <el-select v-model="ruleForm.bfdjz" placeholder="辈分第几字" style="width:100px">
                            <el-option value="1"></el-option>
                            <el-option value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="辈分用字">
                        <el-input v-model="ruleForm.bfyz"></el-input>
                    </el-form-item>
                    <el-form-item label="排行">
                        <el-input v-model="ruleForm.ph"></el-input>
                    </el-form-item>
                    <el-form-item label="性别">
                        <el-radio-group v-model="ruleForm.sex">
                            <el-radio label="0">男</el-radio>
                            <el-radio label="1">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="生日类型">
                        <el-radio-group v-model="ruleForm.srlx">
                            <el-radio label="0">公元</el-radio>
                            <el-radio label="1">朝代</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="朝代">
                        <el-input v-model="ruleForm.cd"></el-input>
                    </el-form-item>
                    <el-form-item label="年号">
                        <el-input v-model="ruleForm.nh"></el-input>
                    </el-form-item>
                    <el-form-item label="生日">
                        <el-date-picker v-model="ruleForm.sr" type="date" placeholder="选择去世时间"> </el-date-picker>
                    </el-form-item>
                    <el-form-item label="民族">
                        <el-input v-model="ruleForm.mz"></el-input>
                    </el-form-item>
                    <Area @mapOpen="mapOpen" :text="{ c: '出生', e: '' }" :dtdz="ruleForm.dtdz" @area="area"></Area>
                    <el-form-item label="生故状态">
                        <el-radio-group v-model="ruleForm.sgzt">
                            <el-radio label="0">在世</el-radio>
                            <el-radio label="1">已故</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="婚姻状态">
                        <el-radio-group v-model="ruleForm.hyzt">
                            <el-radio label="0">未婚</el-radio>
                            <el-radio label="1">已婚</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否开放个人信息">
                        <el-checkbox v-model="ruleForm.kfgrxx"></el-checkbox>
                    </el-form-item>
                    <el-form-item label="生肖">
                        <el-select v-model="ruleForm.sx" placeholder="请选择">
                            <el-option value="鼠"></el-option>
                            <el-option value="牛"></el-option>
                            <el-option value="虎"></el-option>
                            <el-option value="兔"></el-option>
                            <el-option value="龙"></el-option>
                            <el-option value="蛇"></el-option>
                            <el-option value="马"></el-option>
                            <el-option value="羊"></el-option>
                            <el-option value="猴"></el-option>
                            <el-option value="鸡"></el-option>
                            <el-option value="狗"></el-option>
                            <el-option value="猪"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="身高">
                        <el-input v-model="ruleForm.sg"></el-input>
                    </el-form-item>
                    <el-form-item label="血型">
                        <!-- <el-input v-model="ruleForm.xx"></el-input> -->
                        <el-select v-model="ruleForm.xx" placeholder="血型" style="width:100px">
                            <el-option value="A"></el-option>
                            <el-option value="B"></el-option>
                            <el-option value="AB"></el-option>
                            <el-option value="O"></el-option>
                            <el-option value="RH阳性"></el-option>
                            <el-option value="RH阴性"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学历">
                        <el-input v-model="ruleForm.xueli"></el-input>
                    </el-form-item>
                    <el-form-item label="学位">
                        <el-input v-model="ruleForm.xw"></el-input>
                    </el-form-item>
                    <el-form-item label="党派">
                        <el-input v-model="ruleForm.dp"></el-input>
                    </el-form-item>
                    <el-form-item label="宗教">
                        <el-input v-model="ruleForm.zj"></el-input>
                    </el-form-item>
                    <el-form-item label="职业">
                        <el-input v-model="ruleForm.zy"></el-input>
                    </el-form-item>
                    <el-form-item label="职业类型">
                        <el-input v-model="ruleForm.zylx"></el-input>
                    </el-form-item>
                    <el-form-item label="职务级别">
                        <el-input v-model="ruleForm.zwjb"></el-input>
                    </el-form-item>
                    <el-form-item label="开放逝藏信息">
                        <el-checkbox v-model="ruleForm.kfscxx"></el-checkbox>
                    </el-form-item>
                    <el-form-item label="去世时间">
                        <el-date-picker v-model="ruleForm.qssj" type="date" placeholder="选择去世时间"> </el-date-picker>
                    </el-form-item>
                    <Area @mapOpen="mapOpen" :text="{ c: '去世', e: 'qs' }" :dtdz="ruleForm.qsdtdz" @area="area"></Area>
                    <el-form-item label="详细地址">
                        <el-input v-model="ruleForm.qsxxdz"></el-input>
                    </el-form-item>
                    <el-form-item label="去世原因">
                        <el-input v-model="ruleForm.qsyy"></el-input>
                    </el-form-item>
                    <el-form-item label="遗传病史">
                        <el-input v-model="ruleForm.ycbs"></el-input>
                    </el-form-item>
                    <el-form-item label="埋葬地址">
                        <el-input v-model="ruleForm.mzdz"></el-input>
                    </el-form-item>
                    <el-form-item label="埋葬地图地址">
                        <el-input v-model="ruleForm.mzdtdz" @focus="mapOpen('mz')"></el-input>
                    </el-form-item>
                    <el-form-item label="埋葬自定义地址">
                        <el-input v-model="ruleForm.mzzdydz"></el-input>
                    </el-form-item>
                    <el-form-item label="埋葬详细地址">
                        <el-input v-model="ruleForm.mzxxdz"></el-input>
                    </el-form-item>
                    <el-form-item label="埋葬方位">
                        <el-input v-model="ruleForm.mzfw"></el-input>
                    </el-form-item>
                    <el-form-item label="是否立碑">
                        <el-radio-group v-model="ruleForm.sflb">
                            <el-radio label="0">否</el-radio>
                            <el-radio label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
                    </el-form-item>
                </el-form>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="dialogMap" width="500" class="map">
            <vmap @getLnglat="getPosi" :formKey="formKey"></vmap>
        </el-dialog>
    </div>
</template>
<script>
import Head from "@/components/header.vue";
import api from "@/request/api";
import vmap from "@/components/vmap.vue";
import Area from "@/components/area.vue";
import orgtree from "@/components/orgtree.vue";

export default {
    data() {
        return {
            dialogMember: false,
            dialogMap: false,
            ruleForm: {
                familyid: localStorage.getItem("fid"),
                fatherid: 2,
                relation: "1",
                type: "0",
                ischange: "0",
                xm: "",
                cxm: "",
                gmyy: "",
                zi: "",
                hao: "",
                shixu: "",
                bfdjz: "",
                bfyz: "",
                ph: "",
                sex: "0",
                srlx: "0",
                cd: "",
                nh: "",
                sr: "",
                mz: "",
                sheng: "",
                shi: "",
                xian: "",
                dtdz: "",
                zdydz: "",
                sgzt: "0",
                hyzt: "0",
                kfgrxx: "",
                sx: "",
                sg: "",
                xx: "",
                xueli: "",
                xw: "",
                dp: "",
                zj: "",
                zy: "",
                zylx: "",
                zwjb: "",
                kfscxx: "",
                qssj: "",
                qssheng: "",
                qsshi: "",
                qsxian: "",
                qsdz: "",
                qsdtdz: "",
                qszdydz: "",
                qsxxdz: "",
                qsyy: "",
                ycbs: "",
                mzdz: "",
                mzdtdz: "",
                mzzdydz: "",
                mzxxdz: "",
                mzfw: "",
                sflb: "0",
                inout: "1",
                qsinout: "1",
                zlhz:""
            },
            type: "",
            formKey: "",
            tableData: [],
            data: {}
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            api.memberListtree(localStorage.getItem("fid")).then((res) => {
                this.data = res.data[0];
            });
        },
        NodeClick(e, data) {
            this.memberData = data;
            if (e.srcElement.localName == "div") {
                this.dialogVisible = true;
            }
        },
        // getList() {
        //     api.memberList(localStorage.getItem("fid")).then((res) => {
        //         console.log(res);
        //         this.tableData = res.data;
        //     });
        // },
        addClick() {
            this.dialogMember = true;
            this.type = "add";
            this.ruleForm = {
                familyid: localStorage.getItem("fid"),
                fatherid: 2,
                relation: "1",
                onceid: 1,
                type: "0",
                ischange: "0",
                xm: "",
                cxm: "",
                gmyy: "",
                zi: "",
                hao: "",
                shixu: "",
                bfdjz: "",
                bfyz: "",
                ph: "",
                sex: "0",
                srlx: "0",
                cd: "",
                nh: "",
                sr: "",
                mz: "",
                sheng: "",
                shi: "",
                xian: "",
                dtdz: "",
                zdydz: "",
                sgzt: "0",
                hyzt: "0",
                kfgrxx: "",
                sx: "",
                sg: "",
                xx: "",
                xueli: "",
                xw: "",
                dp: "",
                zj: "",
                zy: "",
                zylx: "",
                zwjb: "",
                kfscxx: "",
                qssj: "",
                qssheng: "",
                qsshi: "",
                qsxian: "",
                qsdz: "",
                qsdtdz: "",
                qszdydz: "",
                qsxxdz: "",
                qsyy: "",
                ycbs: "",
                mzdz: "",
                mzdtdz: "",
                mzzdydz: "",
                mzxxdz: "",
                mzfw: "",
                sflb: "0",
                inout: "1",
                qsinout: "1",
                zlhz:""
            };
        },
        submitForm() {
            if (this.type == "add") {
                api.memberAdd(this.ruleForm).then((res) => {
                    if (res.code == 0) {
                        this.getList();
                        this.$message({
                            message: "添加成功"
                        });
                        this.dialogMember = false;
                    }
                });
            } else {
                api.memberEdit(this.ruleForm).then((res) => {
                    if (res.code == 0) {
                        this.getList();
                        this.$message({
                            message: "修改成功"
                        });
                        this.dialogMember = false;
                    }
                });
            }
        },

        editClick(row) {
            this.dialogMember = true;
            this.type = "eidt";
            this.ruleForm = {
                id: row.id,
                type: row.type,
                ischange: row.ischange,
                xm: row.xm,
                cxm: row.cxm,
                gmyy: row.gmyy,
                zi: row.zi,
                hao: row.hao,
                shixu: row.shixu,
                bfdjz: row.bfdjz,
                bfyz: row.bfyz,
                ph: row.ph,
                sex: row.sex,
                srlx: row.srlx,
                cd: row.cd,
                nh: row.nh,
                sr: row.sr,
                mz: row.mz,
                sheng: row.sheng,
                shi: row.shi,
                xian: row.xian,
                dtdz: row.dtdz,
                zdydz: row.zdydz,
                sgzt: row.sgzt,
                hyzt: row.hyzt,
                kfgrxx: row.kfgrxx,
                sx: row.sx,
                sg: row.sg,
                xx: row.xx,
                xueli: row.xueli,
                xw: row.xw,
                dp: row.dp,
                zj: row.zj,
                zy: row.zy,
                zylx: row.zylx,
                zwjb: row.zwjb,
                kfscxx: row.kfscxx,
                qssj: row.qssj,
                qssheng: row.qssheng,
                qsshi: row.qsshi,
                qsxian: row.qsxian,
                qsdz: row.qsdz,
                qsdtdz: row.qsdtdz,
                qszdydz: row.qszdydz,
                qsxxdz: row.qsxxdz,
                qsyy: row.qsyy,
                ycbs: row.ycbs,
                mzdz: row.mzdz,
                mzdtdz: row.mzdtdz,
                mzzdydz: row.mzzdydz,
                mzxxdz: row.mzxxdz,
                mzfw: row.mzfw,
                sflb: row.sflb,
                inout: row.inout,
                qsinout: row.qsinout,
                zlhz:row.zlhz
            };
        },
        delClick(row) {
            api.memberDel(row.id).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        message: "修改成功"
                    });
                    this.getList();
                    this.dialogMember = false;
                }
            });
        },
        viewClick(row) {
            api.memberGet(row.id).then((res) => {
            });
        },
        mapOpen(key) {
            this.formKey = key + "dtdz";
            this.dialogMap = true;
        },
        getPosi(lng, lat, address, key) {
            this.dialogMap = false;
            this.ruleForm[key] = address;
        },
        area(sheng, shi, xian, dt, zdy, key) {
            this.ruleForm[key + "sheng"] = sheng;
            this.ruleForm[key + "shi"] = shi;
            this.ruleForm[key + "xian"] = xian;
            this.ruleForm[key + "dtdz"] = dt;
            this.ruleForm[key + "zdydz"] = zdy;
        }
    },
    components: {
        Head,
        vmap,
        Area,
        orgtree
    }
};
</script>

<style lang="less" scoped>
.member {
    overflow: hidden;
    height: 100%;

    .chartTop {
        height: 55px;
        line-height: 55px;

        h1 {
            width: 350px;
            font-size: 20px;
        }
    }

    .el-dialog__body {
        max-height: 410px;
        overflow: auto;
    }
    .chart {
        width: 100%;
        height: 100%;
        overflow: auto;
        text-align: center;

        .org-tree-container {
            background-color: #f2eee4;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/member.vue